module.exports = "mat-form-field, textarea {\n  width: 100%;\n  height: 80px;\n  margin-bottom: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/atoms/note-details/note-details.component.scss
// module id = ./src/app/components/atoms/note-details/note-details.component.scss
// module chunks = main